"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _authentication = _interopRequireDefault(require("./authentication"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (construct, fieldName) => (state, _, __, rootGetters) => ({
  dispatch
}) => (0, _authentication.default)({
  dispatch,
  getters: rootGetters
}).wrapper(construct, fieldName)(state);

exports.default = _default;